import AccessBoundary from './access-boundary';

export default AccessBoundary;